import axios from "axios";
import React, {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import {baseUrl} from '../PatUniv.js'
function PatLabReportOpAll(props) {
    const {appt_id} = useParams();
    const [viewlabdata, setViewLabData] = useState([]);
    const [labtestData, setLabTestData] = useState([]);
    const [fetchedResults, setFetchedResults] = useState([]); // Declare fetchedResults state here
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(baseUrl + 'pat-lab-report-all/' + appt_id + '/');
                setLabTestData(response.data);
                setIsLoading(false);
            } catch (error) {
                console.log(error);
                setIsLoading(false);
            }
        };
        fetchData();
    }, [appt_id]);
    useEffect(() => {
        if (labtestData.length > 0) {
            fetchLabData();
        }
    }, [labtestData]);
    async function fetchLabData() {
        const fetchedData = [];
        const allFetchedResults = [];
        for (const test of labtestData) {
            const ltestIds = test.ltest_id.split(',').map(item => item.trim());
            const results = test.results.split(',').map(item => item.trim());
            for (const ltestId of ltestIds) {
                try {
                    const response = await axios.get(baseUrl + 'pat-lab-test-view/' + ltestId + '/');
                    fetchedData.push(response.data);
                } catch (error) {
                    console.log(error);
                }
            }
            allFetchedResults.push(...results);
        }
        setViewLabData(fetchedData);
        setFetchedResults(allFetchedResults);
    }
    console.log(fetchedResults)
    if (isLoading) {
        return <div>Loading...</div>;
    }
    const updatedLabbillData = viewlabdata.map((testsArray, groupIndex) =>
        testsArray.map((test, testIndex) => {
            const pharmData = viewlabdata.find((data) => data.id == test);
            const flattenedIndex = groupIndex * testsArray.length + testIndex;
            const results = fetchedResults[flattenedIndex];
            return (
                <tr key={`${groupIndex}-${testIndex}`}>
                    <td>{test.test}</td>
                    <td>{results}</td>
                    <td>{test.units}</td>
                    <td>{test.ranges}</td>
                </tr>
            );
        })
    );
    return (
        <section>
            <div id="invoice-print">
                {labtestData.map((row, index) =>
                    <div>
                        <table className="erp-table-modern">
                            <tr>
                                <th className="mx-0 ps-5" rowSpan="10">
                                    Name : {row.pat.patient}
                                    <br></br>
                                    PID : {row.pat.pat_id}<br></br>
                                    Consultant : Dr.{row.cons.consultant}
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    Gender : {row.pat.gender}
                                    <br></br>
                                    Age : {row.pat.age}
                                    <br></br>
                                    Sample Date : {labtestData[0].sample_date}
                                </th>
                            </tr>
                        </table>
                    </div>
                )}
                <div>
                    <table className="erp-table-modern">
                        <thead>
                        <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                            <th align="left">Test</th>
                            <th align="left">Result</th>
                            <th align="left">Units</th>
                            <th align="left">Ranges</th>
                        </tr>
                        </thead>
                        <tbody>
                        {updatedLabbillData}

                        </tbody>
                    </table>
                </div>
            </div>
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <button style={{padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff'}}>
                    Print
                </button>
            </div>
        </section>
    );
}
export default PatLabReportOpAll;

